export default __webpack_public_path__ + "static/media/member.1c4c8e38.png";